import type { Item } from '@mimir/common/dto/searchResultHit';
import type { RelatedItem } from '@mimir/common/dto/relationModels';


export function toRelatedItem(item: Item | RelatedItem | null): RelatedItem | null {
  if (item === null) {
    return null;
  }
  if (!('metadataVersion' in item)) {
    return null;
  }
  return { ...item }
}
